import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from '~/components/Header';
import LoadingOverlay from '~/components/LoadingOverlay';
import ExplorerSidebar from '~/containers/viewer/explorer-sidebar';
import ReviewStructureSet from '~/containers/viewer/review-structure-set';

export default function ViewerLayout() {
    return (
        <Box>
            <Header />
            <Box display="flex" sx={{ overflow: 'hidden' }}>
                <ExplorerSidebar />
                <Box
                    height="100vh"
                    display="grid"
                    flexGrow={1}
                    gridTemplateRows="auto 1fr"
                    overflow="hidden"
                >
                    <LoadingOverlay />
                    <Toolbar variant="dense" />
                    <Outlet />
                </Box>
                <ReviewStructureSet />
            </Box>
        </Box>
    );
}
